// 在webview已引入好了，这里直接使用类型即可
import type Cloud from "@tbmp/mp-cloud-sdk";

const cloud = window["cloud"]?.default as typeof Cloud;

try {
    if (cloud) {
        cloud.init({
            env: "online",
        });
    }
} catch (error) {}

/**
 * 千牛侧 cloud 服务sdk
 *
 * 比如http请求需要通过此处
 */
export default cloud;
